import React from "react";
import classNames from "classnames";
import { ModulePagerProps } from ".";

const ModulePagerDesktop/* : React.FC<ModulePagerProps> */ = <T,>({ pager, items, className, renderItem, ...rest }: React.PropsWithChildren<ModulePagerProps<T>>) => {
   return <div {...rest} className={classNames("module-pager-wrapper", className)} ref={(node) => { pager.setPagerElement(node); }}>
      <div
         className="module-pager-outer"
         style={{
            transform: `translateX(${pager.renderProps.wrapperTranslateX}px)`,
            width: pager.renderProps.wrapperWidth
         }}>
         <div
            className="module-pager-inner"
            style={{
               gap: pager.gapWidth,
               transform: `translateX(${pager.renderProps.itemTranslateX}px)`
            }}>
            {
               items
                  .slice(pager.renderProps.startIndex, pager.renderProps.endIndex)
                  .map(item => renderItem(item, { width: pager.itemWidth }))
            }
         </div>
      </div>
   </div>
};

export default ModulePagerDesktop;